<template>



<div class="div_box">


<center>
  <p>
    Connect your Metamask.
    <br><br>
    <button class="button-85" @click="connectToMetaMask">Connect 🦊</button>
  </p>
  <br>

  <div class="card">
        <div class="info">
          <p>Connected address: <br></p>
      </div>
    
    </div>

  <p>
  <input size="100"  placeholder="User Address" type="text" name="userAddress" class="form__input" v-model="userAddress" readonly/>
  </p>
  
  <p>
    <label for="name" class="">Your PLAT Balance</label>
  </p>

  <p>
    <br>
  <input size="100"  placeholder="Balance" type="text" name="Balance" class="form__input_text_big" v-model="Balance" readonly/>
  </p>

</center>
</div>

  <div class="hello">
    
    <div class="div_box">
      <center>
    <p><label for="name" class="form__label">TOTAL PLAT STAKED</label>
      <br><br>
      <input size="100"  placeholder="" type="text" name="totalStaked" class="form__input_text_big" v-model="totalStaked" readonly/>
    </p>
  
    <br>



    <p><label for="name" class="form__label">% APY</label>
      <br>
      
      <input size="100"  placeholder="" type="text" name="totalStaked" class="form__input_text_big" v-model="stakeAPY" readonly/>
    </p>
  </center>
    </div>
    <br>
    


  
  </div>

  <div class="div_box">
   
    <table class="table">
         

  <tr>              <td>Enter the amount of $PLAT you want to stake; the minimum is 1 Bi </td></tr>
  <tr>              <td>Lockout period is 150 days.</td></tr>
  <br>
      <tr>

              <td >
                  <input  class="form__input_text_big_2"  type="number" id="quantity" name="quantity" min="1000000000" max="1000000000000000000000000000000000" v-model="quantity" >
                  <br>
                  <button class="btn btn-1 btn-sep icon-info" id="addStake" @click="getAllowance"> Stake </button>
              </td>

            </tr>
     </table>



    <br>

  </div>

  <div class="div_box">
          <table id="stakeTable" class="table">
              <th>Amount</th>
              <th>Date Stake</th>
              <th>Unstake from</th>
              <th>Estimated earnings</th>
              <th></th>
          </table>
    

        </div>
        <br><br>
  

        <br><br><br><br><br><br><br><br>
</template>

<script>
import { ethers } from "ethers";
//import $ from 'jquery';

export default {
  name: 'UserWallet',
  props: {
    msg: String
  }, data() {
      return {
        userAddress: '',
        Balance: '',
        quantity: '',
        totalStaked: '',
        contractAddress: "0x6EC063057eE3D6fE80f913204172762922d507Cc", // token
        contractDFAddress: "0xC46d4e45010812Ac1ba9B0E389C1EF259Ad61560", // Staking contract
      }
    },methods: {
        async connectToMetaMask() {
            if (window.ethereum) {
              try {
                // Solicita a MetaMask para se conectar
                const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
                this.statusMessage = `Conectado: ${accounts[0]}`;

                this.userAddress = accounts[0];
                this.getAPY();
                this.getTotalStaked();
                this.getTokenBalance();
                this.getStakeds();
              } catch (error) {
                console.error('Erro ao conectar MetaMask:', error);
                this.statusMessage = 'Erro ao conectar.';
              }
            } else {
              this.statusMessage = 'MetaMask não está instalada!';
            }
          },
           
         getBalance(_address){
          console.log("Received: "+ _address) 
          _address = _address +""
          var address = ethers.utils.getAddress(_address)
          this.userAddress = ethers.utils.getAddress(_address)
          window.ethereum.request({
            method:'eth_getBalance', 
            params: [address[0], 'latest']
          }).then(balance => {
            // Return string value to convert it into int balance
            console.log(balance) 
              
            // Yarn add ethers for using ethers utils or
            // npm install ethers
            //console.log(window.ethereum.utils.formatEther(balance))
            console.log("Amount Ether: " + ethers.utils.formatEther(balance))

            //contracts(address)
            // Format the string into main latest balance
          })
        }, getTokenBalance(){
              const ethers = require('ethers')

              
              // The Contract interface
              let abi = [
                "function totalSupply() external view returns (uint256)",
                "function balanceOf(address account) external view returns (uint256)",
                "function allowance(address owner, address spender) external view returns (uint256)",
                "function transfer(address recipient, uint256 amount) external returns (bool)",
                "function approve(address spender, uint256 amount) external returns (bool)",
                "function transferFrom(address sender, address recipient, uint256 amount) external returns (bool)",
                "event Transfer(address indexed from, address indexed to, uint256 value)",
                "event Approval(address indexed owner, address indexed spender, uint256 value)"
              ]


             let provider = ethers.getDefaultProvider("https://polygon-rpc.com");

              let contract = new ethers.Contract(this.contractAddress, abi, provider)

    
            try{            
              console.log("Wallet ->> " + this.userAddress);
            contract.balanceOf(this.userAddress+"").then(balance => {
                  // Return string value to convert it into int balance
                  console.log("$Balance: " + ethers.utils.formatEther(balance)) ;
                  balance = ethers.utils.formatEther(balance);
                  this.Balance = Number(parseFloat(balance).toFixed(2));
                  
                })

              }catch (error){
                console.log(error);
              }

          }, getAPY(){
              const ethers = require('ethers')
              
              // The Contract interface
              let abi = [{
                          "inputs": [],
                          "name": "apy",
                          "outputs": [
                            {
                              "internalType": "uint256",
                              "name": "",
                              "type": "uint256"
                            }
                          ],
                          "stateMutability": "view",
                          "type": "function"
                        }]


              let provider = ethers.getDefaultProvider("https://polygon-rpc.com");
              
              let contract = new ethers.Contract(this.contractDFAddress, abi, provider)

    
        
            
            contract.apy().then(balance => {
                  // Return string value to convert it into int balance
                  console.log("APY: json " + JSON.stringify(  balance ));
                  console.log("APY : " + ethers.utils.formatEther(balance)) ;
                  balance = ethers.utils.formatEther(balance);

                  let numeroConvertido = parseFloat(balance) * Math.pow(10, 18);
                  let resultadoFinal = numeroConvertido.toPrecision(2); // Limita para 2 d�gitos significativos

                  this.stakeAPY = resultadoFinal + '%';
                  //this.Balance = ethers.utils.formatEther(balance);
                  
                })

          }, getTotalStaked(){
              const ethers = require('ethers')

              
              // The Contract interface
              let abi = [{
                "inputs": [],
                "name": "getTotalStakedAllUsers",
                "outputs": [
                  {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                  }
                ],
                "stateMutability": "view",
                "type": "function"
              }]


              let provider = ethers.getDefaultProvider("https://polygon-rpc.com");
            
              let contract = new ethers.Contract(this.contractDFAddress, abi, provider)

    
        
            
            contract.getTotalStakedAllUsers().then(balance => {
                  // Return string value to convert it into int balance
                  console.log("$TOTAL Staked balance: json " + JSON.stringify(  balance ));
                  console.log("$TOTAL Staked balance: " + ethers.utils.formatEther(balance)) ;
                  this.totalStaked = ethers.utils.formatEther(balance);
                  //this.Balance = ethers.utils.formatEther(balance);
                  
                })

          },getStakeds(){
              const ethers = require('ethers')

              var intRet = 0;
              // The Contract interface
              let abi = [{
                "inputs": [
                  {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                  }
                ],
                "name": "currentIndex",
                "outputs": [
                  {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                  }
                ],
                "stateMutability": "view",
                "type": "function"
              },
              {
                  "inputs": [
                    {
                      "internalType": "address",
                      "name": "user",
                      "type": "address"
                    },
                    {
                      "internalType": "uint256",
                      "name": "index",
                      "type": "uint256"
                    }
                  ],
                  "name": "getStakeDetailsByIndex",
                  "outputs": [
                    {
                      "internalType": "uint256",
                      "name": "",
                      "type": "uint256"
                    },
                    {
                      "internalType": "uint256",
                      "name": "",
                      "type": "uint256"
                    },
                    {
                      "internalType": "uint256",
                      "name": "",
                      "type": "uint256"
                    }
                  ],
                  "stateMutability": "view",
                  "type": "function"
                }
            
            ]


              let provider = ethers.getDefaultProvider("https://polygon-rpc.com");

              let contract = new ethers.Contract(this.contractDFAddress, abi, provider)

    
              contract.currentIndex(this.userAddress+'').then(balance => {
                  // Return string value to convert it into int balance
                  //console.log("Staking indexes: json " + JSON.stringify(  balance ));
                  //console.log("Staking indexes : " + ethers.utils.formatEther(balance)) ;
                  console.log("Staking indexes INT: " + balance.toNumber()) ;
                  //this.Balance = ethers.utils.formatEther(balance);
                  intRet = parseInt(balance);
                  console.log("intRet: " + intRet);
                 
                  for (let i = 1; i <= intRet; i++){
                    console.log("i: " + i);
                    this.getStakedBI(i);
                  }
                  
                })

          }, getStakedBI(stakeIndex){
              const ethers = require('ethers')

              
              
              // The Contract interface
              let abi = [{
                "inputs": [
                  {
                    "internalType": "address",
                    "name": "",
                    "type": "address"
                  }
                ],
                "name": "currentIndex",
                "outputs": [
                  {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                  }
                ],
                "stateMutability": "view",
                "type": "function"
              },
              {
                "inputs": [
                  {
                    "internalType": "address",
                    "name": "user",
                    "type": "address"
                  },
                  {
                    "internalType": "uint256",
                    "name": "index",
                    "type": "uint256"
                  }
                ],
                "name": "getStakeDetailsByIndex",
                "outputs": [
                  {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                  },
                  {
                    "internalType": "uint256",
                    "name": "",
                    "type": "uint256"
                  }
                ],
                "stateMutability": "view",
                "type": "function"
              }
            
            ]


              let provider = ethers.getDefaultProvider("https://polygon-rpc.com");

              let contract = new ethers.Contract(this.contractDFAddress, abi, provider)



              console.log("Staking indexes INT");

               

                  var table = document.getElementById("stakeTable");
                  var sizeTable = table.rows.length;
                    
                  for (var y = 0; y < sizeTable-1 ; y++) {
                    table.deleteRow(1);
                  }


                          contract.getStakeDetailsByIndex( this.userAddress + "" , stakeIndex  ).then(balance => {
                          console.log("Quant : " + balance[0] + " Staked " + balance[1]  + " Stake to" + balance[2]  + " earned: " + balance[3] ) ;
                          //stakeIndex = parseInt(balance);
                          //console.log("intRet: " + stakeIndex);
                          console.log("intRet i: " + stakeIndex);
                      


                          var amount = ethers.utils.formatEther(balance[0]);

                            if (amount > 0){
                            var amountEarned = ethers.utils.formatEther(balance[3]);
                            amountEarned = Number(parseFloat(amountEarned).toFixed(2));

                            var convertdate = new Date(balance[1] * 1000);

                              
                            var year = convertdate.getFullYear();
                            var month = ('0' + (convertdate.getMonth() + 1)).slice(-2); 
                            var day = ('0' + convertdate.getDate()).slice(-2); 
                            var hours = ('0' + convertdate.getHours()).slice(-2); 
                            var minutes = ('0' + convertdate.getMinutes()).slice(-2); 
                            var seconds = ('0' + convertdate.getSeconds()).slice(-2); 
                            

                            convertdate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;

                            var convertdate2 = new Date(balance[2] * 1000);

                            year = convertdate2.getFullYear();
                            month = ('0' + (convertdate2.getMonth() + 1)).slice(-2); 
                            day = ('0' + convertdate2.getDate()).slice(-2); 
                            hours = ('0' + convertdate2.getHours()).slice(-2); 
                            minutes = ('0' + convertdate2.getMinutes()).slice(-2); 
                            seconds = ('0' + convertdate2.getSeconds()).slice(-2); 
              
                                          
                            var currentDate = new Date();

                            var buttonLib = false;

                            if (currentDate > convertdate2) {
                              buttonLib = true;
                            } else {
                              buttonLib = false;
                            }

                            convertdate2 = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;

                              console.log("convertdate " + convertdate);

                              
                              console.log("_ReadyToWithdraw: " + balance[2]) ;
                              console.log("_Staked: " + balance[3]) ;


                              var row = table.insertRow(table.rows.length);
                              var cell1 = row.insertCell(0);
                              var cell2 = row.insertCell(1);
                              var cell3 = row.insertCell(2);
                              var cell4 = row.insertCell(3);
                              var cell5 = row.insertCell(4);

                              cell1.innerHTML = amount;
                              cell2.innerHTML = convertdate;
                              cell3.innerHTML = convertdate2;
                              //cell3.innerHTML = readyToWithdraw;
                              cell4.innerHTML = amountEarned; // calc earnings estimated

                            
                              if (amount == 0){
                                buttonLib = false;
                              }

                              console.log("i:"+ stakeIndex)
                              var x = document.createElement("button");
                              x.textContent = "UnStake " ;
                              x.classList.add("button-85");
                              x.setAttribute("data-index", stakeIndex);
                              x.id = stakeIndex;
                            
                              if ( buttonLib){
                                x.addEventListener("click", (event) => {
                                  var dataIndex = event.currentTarget.getAttribute("data-index");
                                  this.removeStaking(dataIndex);
                                });

                              }else{
                                x.addEventListener("click", () => {
                                  alert("Stake still locked");
                                });
                                
                              }


                              cell5.append(x);
                            }


                        })



          },staking(){
                    
                    if ( this.quantity > this.Balance){

                      alert("Stake amount exceeds your balance");
                      return;
                    }
                    let    abi = [{
                                "inputs": [
                                  {
                                    "internalType": "uint256",
                                    "name": "amount",
                                    "type": "uint256"
                                  }
                                ],
                                "name": "stake",
                                "outputs": [],
                                "stateMutability": "nonpayable",
                                "type": "function"
                              }]
      
                            
                          console.log("Get provider");
                            const provider = new ethers.providers.Web3Provider(window.ethereum)
      
                            console.log("userAddress: " + this.userAddress);
                            const signer = provider.getSigner(this.userAddress+"");
                          // const contractAddress = "0x7D81e7128c51F815f4d7b4C7C17025304C864166";
      
                            console.log("Get contract");
                          
                          // const contract = new ethers.Contract(contractAddress, abi, signer);
                          const contract = new ethers.Contract(this.contractDFAddress, abi, provider);
      
                          const daiWithSigner = contract.connect(signer);
                          
                          console.log("User " + this.userAddress + " Qtd  " + ethers.utils.parseEther(this.quantity +'') );
                          
                          daiWithSigner.stake(ethers.utils.parseEther(this.quantity +'')).then( ret => {
                              // Return string value to convert it into int balance
                              console.log("Stake Ret: " + JSON.stringify(ret) ) ;
      
                              
                              try{
                                console.log(ret.hash);
                                alert('You can see this transaction in BSC Scan by the link below, https://polygonscan.com/tx/'+ret.hash+'  ');

                                setTimeout(() => this.getStakeds(), 20000);
                                setTimeout(() => this.getTokenBalance(), 20000);

                                
                                
                              }catch (error){
                                alert("Error in Stake - " + error.message );
                                console.log("Error in Stake - " + error);
                                setTimeout(() => this.getStakeds(), 20000);
                                setTimeout(() => this.getTokenBalance(), 20000);
                                
                              }
                           
                              
                            }).catch(error => {
                                alert("Error in Stake - " + error.message);
                                console.log("Error in Stake - " + error.message);
                                setTimeout(() => this.getStakeds(), 20000);
                                setTimeout(() => this.getTokenBalance(), 20000);
                            });
                            
          },approve(){
                    
                    //let nftid = 1;
                   // console.log("NFT: " + nftid);
                    let userWallet;
       
                    let    abi = [{
                                    "inputs": [
                                        {
                                            "internalType": "address",
                                            "name": "spender",
                                            "type": "address"
                                        },
                                        {
                                            "internalType": "uint256",
                                            "name": "value",
                                            "type": "uint256"
                                        }
                                    ],
                                    "name": "approve",
                                    "outputs": [
                                        {
                                            "internalType": "bool",
                                            "name": "",
                                            "type": "bool"
                                        }
                                    ],
                                    "stateMutability": "nonpayable",
                                    "type": "function"
                                  }]
    
                          
                        console.log("Get provider");
                          const provider = new ethers.providers.Web3Provider(window.ethereum)
    
                          const signer = provider.getSigner(userWallet);
    
                          console.log("Get contract");
                        
                        // const contract = new ethers.Contract(contractAddress, abi, signer);
                        const contract = new ethers.Contract(this.contractAddress, abi, provider);
    
                        const daiWithSigner = contract.connect(signer);
                        
    
                        daiWithSigner.approve(this.contractDFAddress,"2000000000000000000000000000000").then( ret => {
                              // Return string value to convert it into int balance
                              console.log("Approve ret: " + JSON.stringify(ret) ) ;
                              alert("Please wait a few seconds as we open your Metamask for you to approve the Stake.");
                              setTimeout(() => this.staking(), 20000);

                            try{
                              console.log(ret.transactionHash);
                            }catch (error){
                              console.log(error);
                              alert("Error in approve contract - " + error );
                            }
    
                            
                          })
    
    
               
                          
            },removeStaking(stakeIndex){


              var _StakeIndex;

              _StakeIndex = stakeIndex;
              console.log("_StakeIndex: " + _StakeIndex )
                    let    abi = [{
                      "inputs": [
                        {
                          "internalType": "uint256",
                          "name": "index",
                          "type": "uint256"
                        }
                      ],
                      "name": "unstake",
                      "outputs": [],
                      "stateMutability": "nonpayable",
                      "type": "function"
                    }]

                  
                      
                    console.log("Get provider - " + _StakeIndex);
                      const provider = new ethers.providers.Web3Provider(window.ethereum)

                      console.log("userAddress: " + this.userAddress);
                      const signer = provider.getSigner(this.userAddress+"");
                  

                      console.log("Get contract");
                    
                  
                    const contract = new ethers.Contract(this.contractDFAddress, abi, provider);

                    const daiWithSigner = contract.connect(signer);
                    
                    console.log("User " + this.userAddress + " Index Staking " + _StakeIndex );
                    
                    daiWithSigner.unstake( _StakeIndex ).then( ret => {
                        // Return string value to convert it into int balance
                        console.log("$Buy ret: " + JSON.stringify(ret) ) ;

                        
                        try{
                          console.log(ret.hash);
                          alert('You can see this transaction in BSC Scan by the link below, https://polygonscan.com/tx/'+ret.hash+'  ');

                          setTimeout(() => this.getStakeds(), 20000);
                          setTimeout(() => this.getTokenBalance(), 20000);

                        }catch (error){
                          console.log(error);
                          setTimeout(() => this.getStakeds(), 20000);
                          setTimeout(() => this.getTokenBalance(), 20000);
                          
                        }
                    
                        
                      });
                      
              },getAllowance(){
                        console.log('Value ' + this.quantity );
                        if( this.quantity < 1000000000 ){
                          alert('The minimun value to staking is 1000000000 $PLAT');
                          return;
                        }
                        
                        let userWallet;
    
                        const ethers = require('ethers');
    
                            let    abi = [{
                                  "inputs": [
                                      {
                                          "internalType": "address",
                                          "name": "owner",
                                          "type": "address"
                                      },
                                      {
                                          "internalType": "address",
                                          "name": "spender",
                                          "type": "address"
                                      }
                                  ],
                                  "name": "allowance",
                                  "outputs": [
                                      {
                                          "internalType": "uint256",
                                          "name": "",
                                          "type": "uint256"
                                      }
                                  ],
                                  "stateMutability": "view",
                                  "type": "function"
                              }]
    
                        
                        console.log("Get provider");
                          const provider = new ethers.providers.Web3Provider(window.ethereum)
    
                          const signer = provider.getSigner(userWallet);
    
                          console.log("Get contract");
                        
                        const contract = new ethers.Contract(this.contractAddress, abi, provider);
    
                        const daiWithSigner = contract.connect(signer);
                        
    
                        daiWithSigner.allowance(this.userAddress+"",this.contractDFAddress).then( ret => {
                            

                            if (ethers.utils.formatEther(ret) >= this.quantity){
                              this.staking();
                            }else{
                              alert("You need to approve the stake contract!");
                              this.approve();
                            }
    
                            try{
                              console.log(ret.transactionHash);
                            }catch (error){
                              console.log(error);
                              
                            }
    
                            
                          })
    
    
 
                }

            },beforeMount() {

              /*
              if (window.ethereum) {
                window.ethereum
                  .request({ method: 'eth_chainId' })
                  .then((chainId) => {
                    if (chainId === '137' || chainId === '0x89') { // change network
                      console.log("Conected in Polygon network:"+chainId)

                      window.ethereum.request({method:'eth_requestAccounts'})
                      .then(res=>{
                              // Return the address of the wallet
                              console.log("Address:" + res) ;
                              this.userAddress = res;
                     
                      })

                    } else {
                      alert('Please connect MetaMask to the Polygon network ' + chainId);
                    }
                  })
                  .catch((error) => {
                    alert('Error checking MetaMask network: ' + error.message);
                  });
              } else {
                alert('MetaMask not detected in the browser.');
              }
                */

                
            }

                                      
}
</script>


<style scoped>

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
    color: rgb(204, 85, 204);
}


.form__label {
  font-family: 'Roboto', sans-serif;
  font-size: 1.2rem;
  margin-left: 2rem;
  margin-top: 0.7rem;
  display: block;
  transition: all 0.3s;
  transform: translateY(0rem);
}

.form__input {
  font-family: 'Roboto', sans-serif;
  color: rgb(204, 85, 204);
  font-size: 0.60rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgba(0, 0, 0, 0.7);
  border: none;
  width: 50%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}

.form__input_nft {
  font-family: 'Roboto', sans-serif;
  color: rgb(204, 85, 204);
  font-size: 0.95rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgba(0, 0, 0, 0.7);
  border: none;
  width: 54%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
  text-size-adjust: 50;
}

.form__input_text_big {
  font-family: 'Roboto', sans-serif;
  color: rgb(204, 85, 204);
  font-size: 1.5rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.9rem;
  background-color: rgba(0, 0, 0, 0.7);
  border: none;
  width: 50%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}

.form__input_text_big_2 {
  font-family: 'Roboto', sans-serif;
  color: rgb(204, 85, 204);
  font-size: 1.5rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.9rem;
  background-color: rgba(0, 0, 0, 0.7);
  border: none;
  width: 62%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}


.form__input:placeholder-shown + .form__label {
  opacity: 0;
  visibility: hidden;
  -webkit-transform: translateY(-4rem);
  transform: translateY(-4rem);
}

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  font-size: 62,5%;
}


.div_box {
  margin: auto;
  border-radius: 0.6rem;
  background-color: rgba(70, 146, 20, 0.096);
  border-color: rgba(185, 185, 193, 0.5);
  border: 0.00rem;
  width: calc(100% - 100px); 
  margin-top: 30px;
  margin-bottom: 3px;
  transition: all 0.3s;
  text-align: justify;
  border-style: solid;
  padding: 50px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
  display: inline-table;
  font-size: medium;
  box-sizing: border-box;
}

.div_boxws {
  margin: auto;
  border-radius: 0.6rem;
  background-color: rgba(70, 146, 20, 0.096);
  border-color: rgba(185, 185, 193, 0.5);
  border: 0.00rem;
  width: calc(100% - 100px); 
  margin-top: 30px;
  margin-bottom: 3px;
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
  padding: 50px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
  display: inline-table;
  font-size: medium;
  box-sizing: border-box; 
}

.subdiv_box {
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  border: 0.05rem;
  width: 90%;
  margin-top: 30px;
  display: inline-table;
  font-size: medium;
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
}

.table{
  margin-left: auto;
  margin-right: auto;
  text-align:center ; 
  width:80%;

  
}



/* CSS */
.button-85 {
  padding: 0.6em 2em;
  border: none;
  outline: none;
  color: rgb(255, 255, 255);
  background: #111;
  cursor: pointer;
  position: relative;
  z-index: 0;
  border-radius: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-85:before {
  content: "";
  background: linear-gradient(
    45deg,
    #ff0000,
    #ff7300,
    #fffb00,
    #48ff00,
    #00ffd5,
    #002bff,
    #7a00ff,
    #ff00c8,
    #ff0000
  );
  position: absolute;
  top: -2px;
  left: -2px;
  background-size: 400%;
  z-index: -1;
  filter: blur(5px);
  -webkit-filter: blur(5px);
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  animation: glowing-button-85 20s linear infinite;
  transition: opacity 0.3s ease-in-out;
  border-radius: 10px;
}


@keyframes glowing-button-85 {
  0% {
    background-position: 0 0;
  }
  50% {
    background-position: 400% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.button-85:after {
  z-index: -1;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #222;
  left: 0;
  top: 0;
  border-radius: 10px;
}




.styled-table {
    margin-left: auto;
    margin-right: auto;
    text-align:center ; 
    width:50%;
    border-collapse: collapse;
    font-size: 0.9em;
    font-family: sans-serif;
    min-width: 60%;
    box-shadow: 0 0 20px solid #cd33cd;
}
.styled-table thead tr {
    background-color: #3357cd;
    color: #ffffff;
    text-align: left;
}
.styled-table th,
.styled-table td {
  white-space:pre;
    padding: 12px 15px;
}
.styled-table tbody tr {
    border-bottom: 2px solid #3357cd;
}

.styled-table tbody tr:nth-of-type(even) {
    background-color: #1E2025;
}

.styled-table tbody tr:last-of-type {
    border-bottom: 2px solid #3357cd;
}

.styled-table tbody tr.active-row {
    font-weight: bold;
    color: #3357cd;
}


.button-42 {
  display: inline-block;
  padding: 0.5em 1.5em;
  border: 0.1em solid #ff69b4;
  margin: 0.5em;
  border-radius: 0.5em;
  box-sizing: border-box;
  text-decoration: none;
  font-family: 'Comic Sans MS', cursive, sans-serif;
  font-weight: 600;
  color: #fff;
  background-color: #ff69b4;
  text-align: center;
  transition: all 0.3s;
}

.button-42:hover {
  color: #ff69b4;
  background-color: #fff;
  border-color: #ff69b4;
}

.div_box {
  margin: auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background-color: rgba(30, 30, 31, 0.5);
  width: 96%;
  max-width: 100%;
  font-size: 17px;
  font-family: 'Courier New', Courier, monospace;
  transition: all 0.3s;
  text-align: justify;
}

.section-title {
  font-size: 1.6rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

p {
  margin-bottom: 1rem;
}

a {
  color: #b942b9;
}

@media (max-width: 768px) {
  .div_box {
    padding: 1rem 1.5rem;
  }

  .section-title {
    font-size: 1.4rem;
  }

  p {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .div_box {
    padding: 0.5rem 1rem;
  }

  .section-title {
    font-size: 1.2rem;
  }

  p {
    font-size: 0.8rem;
  }
}



.btn {
  border: none;
  font-family: 'Lato';
  font-size: inherit;
  color: inherit;
  background: none;
  cursor: pointer;
  padding: 25px 80px;
  display: inline-block;
  margin: 15px 30px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  outline: none;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}

.btn:after {
  content: '';
  position: absolute;
  z-index: -1;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}

/* Pseudo elements for icons */
.btn:before {
  font-family: 'FontAwesome';
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  position: relative;
  -webkit-font-smoothing: antialiased;
}


/* Icon separator */
.btn-sep {
  padding: 25px 60px 25px 120px;
}

.btn-sep:before {
  background: rgba(0,0,0,0.15);
}

/* Button 1 */
.btn-1 {
  background: #3498db;
  color: #fff;
}

.btn-1:hover {
  background: #2980b9;
}

.btn-1:active {
  background: #2980b9;
  top: 2px;
}

.btn-1:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Button 2 */
.btn-2 {
  background: #2ecc71;
  color: #fff;
}

.btn-2:hover {
  background: #27ae60;
}

.btn-2:active {
  background: #27ae60;
  top: 2px;
}

.btn-2:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Button 3 */
.btn-3 {
  background: #e74c3c;
  color: #fff;
}

.btn-3:hover {
  background: #c0392b;
}

.btn-3:active {
  background: #c0392b;
  top: 2px;
}

.btn-3:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Button 3 */
.btn-4 {
  background: #34495e;
  color: #fff;
}

.btn-4:hover {
  background: #2c3e50;
}

.btn-4:active {
  background: #2c3e50;
  top: 2px;
}

.btn-4:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}

/* Icons */

.icon-cart:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}

.icon-heart:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}

.icon-info:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}

.icon-send:before {
  content: "\1F4B0";
  font-size: 24px;
  margin-right: 5px;
}

</style>